import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';

import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  ComplianceAreaService,
  ControlItemsService,
  ProjectService,
  TenantService,
  UploadService,
} from '../../_services/index';

import {ComplianceArea, ControlItem, Project, User,} from '../../_models/index';

import {MenuItem, SelectItem} from 'primeng/api';

import {Role} from '../../helpers/role';

import {ControlItemComponent} from '../controlItem/index';

import {UploadComplianceAreaComponent} from '../uploadComplianceArea/index';

import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {Constants} from '../../helpers/constants';
import {saveAs as importedSaveAs} from "file-saver";
import {IndexConfigService} from "../../_services/index.config.service";
import {EditComplianceAreaComponent} from "../editComplianceArea/edit.complianceArea.component";
import {ListMessageComponent} from "../listMessage";
import {LoginHelper} from "../../helpers";
import {ConfirmComponent} from "../confirm";
import {TenantPermissions} from "../../_models/tenantPermissions";

@Component({
    standalone: false,
  selector: "control-items-component",
  templateUrl: 'control.items.component.html',
  styleUrls: ['./control.items.component.scss'],
})

export class ControlItemsComponent implements OnInit, OnDestroy {
  projectId: string;
  controlItems: ControlItem[];
  msg: string;
  currentUser: User;
  upload: any;
  allControlItems: ControlItem[];
  canManageControlItems: Boolean;
  canUploadComplianceArea: boolean;
  complianceAreas: ComplianceArea[];
  selectedComplianceArea: ComplianceArea;
  menuItems: MenuItem[];
  NoneComplianceArea: ComplianceArea = null;
  updatedAreas: number = 0;
  categoriesFilter: SelectItem[];
  tenantName: string;
  master: string = Constants.RiskSpongeMaster;
  isMaster: boolean = false;
  allChecked: boolean;
  isNotConsultant: boolean;
  subVisible = {};
  dialogRef: MatDialogRef<ControlItemComponent> | null;
  dialogRef1: MatDialogRef<UploadComplianceAreaComponent> | null;
  selectedIndex = 1;
  cols: any[] = [
    {'field': 'category', 'header': 'Category'},
    {'field': 'complianceAreaControlId', 'header': 'Control ID'},
    {'field': 'description', 'header': 'Description'}
  ];
  tenantPermissions: TenantPermissions = {};
  rowGroupMetadata = {};
  navigationSubscription: any;
  settings: any;
  isMappingTemplateVisible: boolean;
  selectedProject: Project;
  implementationStatusCount: any;
  implementationStatusData: any;
  implementationStatusBarOptions: any;
  userToken = LoginHelper.getFileToken();
  predictions: any[];
  predictionData: any[];
  predictionOptions: any[];
  projects: any[];
  implementationStatuses: any =
    {
      0: "None",
      1: "Implemented",
      2: "Partially Implemented",
      3: "Planned",
      4: "Alternative Implementation",
      5: "Not Applicable",
      7: "Not Implemented"
      /*6: "Ongoing",*/
    };
  constants = Constants;

  constructor(
    public route: ActivatedRoute,
    public clientProfileService: ClientProfileService,
    public router: Router,
    public controlItemsService: ControlItemsService,
    public authenticationService: AuthenticationService,
    public alertService: AlertService,
    public uploadService: UploadService,
    public complianceAreaService: ComplianceAreaService,
    public dialog: MatDialog,
    public tenantService: TenantService,
    public projectService: ProjectService,
    public config: IndexConfigService) {
    //this.projectId = route.snapshot.params['projectId'];
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        this.selectedComplianceArea = null;
        this.ngOnInit();
      }
    });
  }

  ngOnInit() {
    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    const tenantName = this.tenantName = this.getTenantName();
    if (tenantName == null) {
      this.authenticationService.logout();
      return;
    }

    if (tenantName.toLowerCase() == 'riskspongemaster') {
      this.isMappingTemplateVisible = true;
    } else {
      this.tenantService.getCurrent().subscribe(p => {
        this.isMappingTemplateVisible = (this.currentUser.role & (Role.KingAdmin | Role.Admin | Role.PrimaryManager | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0 && p.isMappingTemplateEnabled;
      });
    }

    this.canManageControlItems = (this.currentUser.role & (Role.PrimaryAdvisorLead | Role.PlatformSupport | Role.KingAdmin | Role.Admin)) != 0;

    this.isMaster = tenantName == Constants.RiskSpongeMaster;
    if (this.isMaster) {
      this.canUploadComplianceArea = true;
    } else {
      this.canUploadComplianceArea = (this.currentUser.role & (Role.PrimaryAdvisorLead | Role.PlatformSupport | Role.KingAdmin | (Role.Manager | Role.PrimaryManager) | Role.Admin)) != 0;
    }

    this.tenantService.getCurrent().subscribe(p => {
      if (p) {
        this.tenantPermissions = p;
      }
    });

    /*this.complianceAreaService.getComplianceAreaUpdateCount(tenantName).subscribe(c =>
      this.updatedAreas = c
    );*/

    this.loadAreas();

    this.selectedComplianceArea = this.NoneComplianceArea;

    this.categoriesFilter = [];

    this.loadControlItems();

    this.menuItems = [
      {label: 'Delete', icon: 'fa-close', command: (event) => this.deleteCheckedControlItems()}
    ];

    this.loadSettings();
  }

  loadAreas() {
    this.complianceAreaService.getInfoComplianceAreas(this.tenantName).subscribe(complianceAreas => {
      this.complianceAreas = complianceAreas;
    });
  }

  download171Template() {
    this.complianceAreaService.downloadTemplate()
      .subscribe(blob => {
          importedSaveAs(new Blob([blob]), '800-171_Template.xlsx');
        },
        error => {
          const errorMessage = error.status == 401 ? 'The logged in user does not have access to the file\'s location. ' : 'The referenced file no longer exists in the document library.';
          this.alertService.error(errorMessage);
        });
  }

  onComplianceAreaChange(event) {
    this.allChecked = false
    //console.log('onComplianceAreaChange');
    //console.log(event);
    if (this.selectedComplianceArea != this.NoneComplianceArea) {
      this.loadControlItems();
    } else {

      this.controlItems = null;
    }

  }

  editControlItem(controlItemId) {
    const controlItem = this.allControlItems.find(x => x.controlItemId == controlItemId);

    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '80%',
      height: '90%',
      data: {
        controlItem: controlItem,
        parent: controlItem.parentControlItemId ? this.allControlItems.find(c => c.controlItemId == controlItem.parentControlItemId) : undefined
      }
    };


    this.dialogRef = this.dialog.open(ControlItemComponent, config);
    //this.dialogRef.disableClose = true;

    this.dialogRef.afterClosed().subscribe((result: any) => {
      this.loadControlItems();
    });
  }

  uploadComplianceArea() {

    let config: MatDialogConfig = {
      /*data: {
        tenant: tenant
      }*/
    };

    this.dialogRef1 = this.dialog.open(UploadComplianceAreaComponent, config);

    this.dialogRef1.afterClosed().subscribe((result: any) => {
      this.complianceAreaService.getInfoComplianceAreas(this.getTenantName())
        .subscribe(complianceAreas => {
          this.complianceAreas = complianceAreas;
        });
    });
  }

  downloadCurrentComplianceArea() {
    window.location.href = `${this.config.api}/api/controlitems/download?complianceAreaId=${this.selectedComplianceArea.complianceAreaId}&token=` + LoginHelper.getFileToken();
  }

  uploadCurrentComplianceArea() {

    let config: MatDialogConfig = {
      data: {
        complianceArea: this.selectedComplianceArea
      }
    };

    this.dialogRef1 = this.dialog.open(UploadComplianceAreaComponent, config);

    this.dialogRef1.afterClosed().subscribe((result: any) => {
      this.complianceAreaService.getInfoComplianceAreas(this.getTenantName())
        .subscribe(complianceAreas => {
          this.complianceAreas = complianceAreas;
        });
    });
  }

  openControlItem(controlItemId: number) {
    //this.projectControlItemService.getById(projectControlItemId)
    //this.router.navigate(['/controlItems/', controlItemId]);

    let controlItem =
      this.controlItems.find(x => x.controlItemId == controlItemId);

    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '80%',
      height: '90%',
      data: {
        controlItem: controlItem
      }
    };


    this.dialogRef = this.dialog.open(ControlItemComponent, config);
    //this.dialogRef.disableClose = true;

    this.dialogRef.afterClosed().subscribe((result: any) => {
      this.loadControlItems();
    });
  }

  deleteControlItem(controlItem: ControlItem) {

    const controlItems = [controlItem];
    this.deleteControlItems(controlItems);
  }

  deleteCheckedControlItems() {

    const controlItems2Delete = this.controlItems.filter(x => x.checked);
    this.deleteControlItems(controlItems2Delete);
  }

  deleteControlItems(controlItems: ControlItem[]) {

    this.controlItemsService.deleteRange(controlItems.map(x => x.controlItemId), this.getTenantName())
      .subscribe(data => {
          if (data.length) {
            let config: MatDialogConfig = {
              panelClass: 'custom-overlay-pane-class',
              width: 'auto',
              height: 'auto',
              data: {
                items: data,

                title: "Delete items"
              }
            };
            this.dialog.open(ListMessageComponent, config);
          } else {
            for (let projectControlItem of controlItems) {
              const index = this.controlItems.indexOf(projectControlItem, 0);
              this.controlItems.splice(index, 1);
            }

            this.controlItems = [...this.controlItems];

            this.updateRowGroupMetaData(this.controlItems);

            if (controlItems.length) {
              this.alertService.success('The items were deleted.', true);
            }
          }
        },
        error => {
          const message = "An error occurred while deleting item.";
          this.alertService.error(message);
        });
  }

  public loadControlItems() {
    if (this.selectedComplianceArea == this.NoneComplianceArea) {
      this.controlItems = [];
      return;
    }

    this.controlItemsService.getComplianceAreaControlItems(this.selectedComplianceArea.complianceAreaId, this.getTenantName())
      .subscribe(controlItems => {

          let i;
          this.controlItems = controlItems.filter(i => !i.parentControlItemId);
          this.updateRowGroupMetaData(this.controlItems);
          this.allControlItems = controlItems;

          const categories = this.controlItems.map(x => x.category);

          for (i = 0; i < categories.length; i++) {
            if (!this.categoriesFilter.map(x => x.label).includes(categories[i])) {
              this.categoriesFilter.push({label: categories[i], value: categories[i]});
            }
          }
        },
        error => {
          const message = "An error occurred while loading items.";
          this.alertService.error(message);
        });
  }


  getTenantName(): string {
    if (this.currentUser == null) {
      return null;
    }

    if (this.currentUser.role == Role.KingAdmin) {
      return Constants.RiskSpongeMaster;
    }

    return this.currentUser.tenantName;
  }

  public uploadControlItems(event) {

    this.alertService.clear();

    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.uploadService.uploadControlItems(file, this.selectedComplianceArea.name).subscribe(
        (res) => {
          let config: MatDialogConfig = {
            panelClass: 'custom-overlay-pane-class',
            width: 'auto',
            height: '90%',
            data: {
              items: res,

              title: "Import report"
            }
          };
          this.dialog.open(ListMessageComponent, config);
          this.loadControlItems();

        },
        (error) => {
          const errorMessage = 'An error occurred while upload control items.';
          this.alertService.error(errorMessage);
        });
    }
  }

  public gotoControlItemUpdates() {
    this.router.navigate(['controlItems/updates']);
  }

  public deleteArea() {
    this.dialog.open(ConfirmComponent, {
      data: {
        title: 'Do you want to delete this Compliance Framework?',
        yes: 'Yes',
        no: 'No',
        confirm: () => this.doDeleteArea(),
        cancel: () => {
        }
      }
    });
  }

  public doDeleteArea() {
    this.alertService.clear();

    this.controlItemsService.deleteArea(this.selectedComplianceArea.complianceAreaId).subscribe(
      (res) => {
        if (res.length > 0) {
          let config: MatDialogConfig = {
            panelClass: 'custom-overlay-pane-class',
            width: 'auto',
            height: 'auto',
            data: {
              items: res,

              title: "Delete area"
            }
          };
          this.dialog.open(ListMessageComponent, config);
        } else {
          const errorMessage = 'Compliance area was deleted';
          this.alertService.success(errorMessage);
          this.complianceAreaService.getInfoComplianceAreas(this.getTenantName()).subscribe(complianceAreas => {
            this.complianceAreas = complianceAreas;
          });
          this.loadControlItems();
        }
      },
      (error) => {
        const errorMessage = 'An error occurred while deleting compliance area';
        this.alertService.error(errorMessage);
      });
  }

  public openCreatePopup() {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '80%',
      height: '90%',
      data: {
        controlItem: {complianceAreaId: this.selectedComplianceArea.complianceAreaId}
      }
    };


    this.dialogRef = this.dialog.open(ControlItemComponent, config);
    //this.dialogRef.disableClose = true;

    this.dialogRef.afterClosed().subscribe((result: any) => {
      this.loadControlItems();
    });
  }

  public updateSelectAll() {
    this.controlItems.forEach(i => i.checked = this.allChecked);
  }

  public updateSelectOne() {
    this.allChecked = !this.controlItems.find(i => !i.checked);
  }

  public editComplianceArea(area) {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '80%',
      height: '90%',
      data: {
        complianceArea: area
      }
    };


    const dialogRef = this.dialog.open(EditComplianceAreaComponent, config);
    //this.dialogRef.disableClose = true;

    dialogRef.afterClosed().subscribe((result: any) => {
      this.loadAreas();
      this.loadControlItems();
    });
  }

  public uploadControlItemsHierarchy(event) {
    this.alertService.clear();

    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.uploadService.uploadControlItemsHierarchy(file).subscribe(
        (res) => {

          let config: MatDialogConfig = {
            panelClass: 'custom-overlay-pane-class',
            width: 'auto',
            height: '90%',
            data: {
              items: res,

              title: "Import report"
            }
          };
          this.dialog.open(ListMessageComponent, config);
          this.loadControlItems();

        },
        (error) => {
          const errorMessage = 'An error occurred while upload control items.';
          this.alertService.error(errorMessage);
        });
    }
  }

  public uploadControlItemsBroadcast(event) {
    this.alertService.clear();

    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.uploadService.uploadControlItemsBroadcast(file).subscribe(
        (res) => {

          let config: MatDialogConfig = {
            panelClass: 'custom-overlay-pane-class',
            width: 'auto',
            height: '90%',
            data: {
              items: res,

              title: "Import report"
            }
          };
          this.dialog.open(ListMessageComponent, config);
          this.loadControlItems();

        },
        (error) => {
          const errorMessage = 'An error occurred while upload control items.';
          this.alertService.error(errorMessage);
        });
    }
  }

  loadSettings() {
    this.clientProfileService.getSettings(this.tenantName).subscribe(t => {
      this.settings = t;
      this.projectService.getUsersAllProjects(this.currentUser.userId).subscribe((p: Project[]) => {
        this.projects = p;
        this.selectedProject = this.projects.find(f => f.projectId == t.defaultProject) || (this.projects.length > 0 ? this.projects[0] : null);
        this.loadSelectedProject();
      });
    });
  }

  isDefaultUpdate(area, event) {
    if (event.checked) {
      this.settings.defaultComplianceAreas.push(area.complianceAreaId);
    } else {
      this.settings.defaultComplianceAreas = this.settings.defaultComplianceAreas.filter(a => a != area.complianceAreaId);
    }
    this.clientProfileService.saveSettings(this.settings, this.tenantName).subscribe(() => this.loadSettings());
  }

  isExtendedUpdate(area, event) {
    area.isExtended = event.checked;
    this.complianceAreaService.update(area)
      .subscribe(
        data => {
          this.alertService.success('The item data was updated.', true);
          this.loadAreas();
        },
        error => {
          const message = "An error occurred while updating item.";
          this.alertService.error(message);
        });
  }

  ngOnDestroy() {
    // avoid memory leaks here by cleaning up after ourselves. If we
    // don't then we will continue to run our initialiseInvites()
    // method on every navigationEnd event.
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  updateRowGroupMetaData(data) {
    this.rowGroupMetadata = {};
    if (data) {

      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        let brand = rowData.category;
        if (i == 0) {
          this.rowGroupMetadata[brand] = {index: 0, size: 1};
        } else {
          let previousRowData = data[i - 1];
          let previousRowGroup = previousRowData.category;
          if (brand === previousRowGroup)
            this.rowGroupMetadata[brand].size++;
          else
            this.rowGroupMetadata[brand] = {index: i, size: 1};
        }
      }
    }
  }

  onProjectChange(event: any) {
    this.loadSelectedProject();
  }

  loadSelectedProject() {

    let dateNow = new Date(Date.now());
    const nextMonth = new Date(dateNow.setMonth(dateNow.getMonth() + 10000)).toISOString();
    dateNow = new Date(Date.now());
    const lastTwoweek = new Date(dateNow.setMonth(dateNow.getDate() - 14)).toISOString();


    this.projectService.getImplementationStatus(this.selectedProject.projectId).subscribe(
      data => {
        //this.selectedProject = data;
        this.implementationStatusCount = data;

        const labels = ['N', 'I', 'PI', 'P', 'AI', 'NA'];
        this.implementationStatusData = {
          datasets: []
          /*{
            label: '',
            backgroundColor: '#d36576',
            data: []
          }*/

        };

        const colors = ['#FE652C', '#1E88E5', '#d36576', '#f43f5c', '#2f4b7c', '#a0f1f5'];

        let max = 0;
        for (let i = 0; i <= 5; i++) {
          this.implementationStatusData.datasets.push({
            label: labels[i],
            backgroundColor: colors[i],
            data: [{x: i, y: data[i] || 0, label: labels[i]}]
          });
          /*this.implementationStatus.datasets.push({
            label: this.implementationStatuses[i],
            backgroundColor: '#d36576',
            data: [data[i]]
          });*/
          //this.implementationStatus.datasets[0].data.push(data[i] || 0);
          //this.implementationStatus.labels.push(this.implementationStatuses[i]);
          max = Math.max(max, data[i]);
        }

        this.implementationStatusBarOptions = {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false
            }
          },
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                return data && data.datasets ? this.implementationStatuses[tooltipItem.datasetIndex] + ":" + data.datasets[tooltipItem.datasetIndex].data[0] : '';
              }
            }
          },
          scales: {
            x: {
              barThickness: 0,
              grid: {
                drawOnChartArea: false,
                color: "rgba(0,0,0,0)"
              }
              //categoryPercentage: 1.0,
              //barPercentage: 1.0,
            },
            y: {
              ticks: {
                min: -25
              },
              gridLines: {
                color: "rgba(0,0,0,0)"
              },
              display: false
            },
          },
          hover: {
            animationDuration: 0
          },
          animation: {
            duration: 0,
            onComplete: function (that) {
              const chartInstance = that.chart,
                ctx = chartInstance.ctx;
              ctx.textAlign = 'center';
              ctx.fillStyle = "rgba(0, 0, 0, 1)";
              ctx.textBaseline = 'bottom';

              this.data.datasets.forEach(function (dataset, i) {
                const meta = chartInstance.getDatasetMeta(i);
                meta.data.forEach(function (bar, index) {
                  const data = dataset.data[index];

                  //console.log(bar);
                  //console.log(ctx);

                  ctx.font = '12px "Helvetica Neue", Helvetica, Arial, sans-serif'

                  ctx.fillText(data.y, bar.x, bar.base || 0);

                  ctx.font = '9px "Helvetica Neue", Helvetica, Arial, sans-serif'
                  ctx.fillText(dataset.label, bar.x, (bar.base || 0) + 12);
                });
              });
            }
          }
        };

        this.implementationStatusBarOptions.scales.y = {
          /*ticks: {
            max: max
          },*/
          display: false
        };

      },
      error => {
        const errorMessage = 'An error occurred while loading project.';
        this.alertService.error(errorMessage);
      });

    this.controlItemsService.getPrediction(this.selectedProject.projectId, this.tenantName).subscribe(
      data => {
        this.predictions = data;
        this.predictionData = [];
        this.predictionOptions = []
        const labels = ['N', 'I', 'PI', 'P', 'AI', 'NA'];
        const colors = ['#FE652C', '#1E88E5', '#d36576', '#f43f5c', '#2f4b7c', '#a0f1f5'];
        for (let a = 0; a < data.length; a++) {
          this.predictionData[a] = {
            datasets: []
            /*{
              label: '',
              backgroundColor: '#d36576',
              data: []
            }*/

          };

          let max = 0;
          for (let i = 0; i <= 5; i++) {
            this.predictionData[a].datasets.push({
              label: labels[i],
              backgroundColor: colors[i],
              data: [{x: i, y: (data[a].statuses[i].count || 0), label: labels[i]}]
            });
            //this.implementationStatus.labels.push(this.implementationStatuses[i]);
            max = Math.max(max, data[a].statuses[i].count);
          }

          this.predictionOptions[a] = {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false
            },
            tooltips: {
              callbacks: {
                label: (tooltipItem, data) => {
                  return data && data.datasets ? this.implementationStatuses[tooltipItem.datasetIndex] + ":" + data.datasets[tooltipItem.datasetIndex].data[0] : '';
                }
              }
            },
            scales: {
              x: {
                display: true,
                barThickness: 0,
                grid: {
                  drawOnChartArea: false,
                  color: "rgba(0,0,0,0)"
                }
                //categoryPercentage: 1.0,
                //barPercentage: 1.0,
              },
              y: {
                ticks: {
                  min: -25
                },
                gridLines: {
                  color: "rgba(0,0,0,0)"
                },
                display: false
              },
            },
            hover: {
              animationDuration: 0
            },
            animation: {
              duration: 0,
              onComplete: function (that) {
                const chartInstance = that.chart,
                  ctx = chartInstance.ctx;
                ctx.textAlign = 'center';
                ctx.fillStyle = "rgba(0, 0, 0, 1)";
                ctx.textBaseline = 'bottom';

                this.data.datasets.forEach(function (dataset, i) {
                  const meta = chartInstance.getDatasetMeta(i);
                  meta.data.forEach(function (bar, index) {
                    const data = dataset.data[index];

                    //console.log(bar);
                    //console.log(ctx);

                    ctx.font = '12px "Helvetica Neue", Helvetica, Arial, sans-serif'

                    ctx.fillText(data.y, bar.x, bar.base || 0);

                    ctx.font = '9px "Helvetica Neue", Helvetica, Arial, sans-serif'
                    ctx.fillText(dataset.label, bar.x, (bar.base || 0) + 12);
                  });
                });
              }
            }
          };

          this.predictionOptions[a].scales.y = {
            /*ticks: {
              max: max
            },*/
            display: false
          };
        }
      },
      error => {
        const errorMessage = 'An error occurred while loading project.';
        this.alertService.error(errorMessage);
      });
  }

  saveOrder(e) {
    const newOrder = this.controlItems[e.dropIndex - 1].order;
    for (let i = e.dragIndex + 1; i < e.dropIndex; i++) {
      this.controlItems[i].order = this.controlItems[i - 1].order;
    }
    this.controlItems[e.dragIndex].order = newOrder;
    this.controlItems = this.controlItems.sort((a, b) => a.order - b.order);
    this.updateRowGroupMetaData(this.controlItems);
    this.controlItemsService.saveOrder(this.controlItems.map(c => [c.controlItemId, c.order])).subscribe(() => {
    });
  }
}
